import React from 'react'
import Xml from 'components/shared/Xml'

const QaResultsItemQuestion = ({
  questionNumber,
  question,
  questionUrl,
  xmlProps,
  isLogged,
  setSignUpModalIsOpen
}) => (
  isLogged
    ? (
      <h2 className='ma0 lh-copy f5 fw6'>
        <a className='black no-underline hover-cadet-blue mr7' href={questionUrl}>
          <span>Q {questionNumber}:&nbsp;</span>
          <Xml render={question} {...xmlProps} />
        </a>
      </h2>
      )
    : (
      <h2
        className='ma0 lh-copy f5 fw6'
        onClick={() => setSignUpModalIsOpen(true)}
      >
        <a className='black no-underline hover-cadet-blue pointer mr7'>
          <span>Q {questionNumber}:&nbsp;</span>
          <span className='f5 lh-copy black'><Xml render={question} {...xmlProps} /></span>
        </a>
      </h2>
      )
)

export default QaResultsItemQuestion
